exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width[data-v-0537d54a]{width:100%}.service-name[data-v-0537d54a]{text-transform:uppercase}.long-service-name[data-v-0537d54a],.service-name[data-v-0537d54a]{font-weight:700;font-size:1.1rem}.long-service-name[data-v-0537d54a]:first-letter{text-transform:uppercase!important}.active-status[data-v-0537d54a]{font-weight:700;color:green}.inactive-status[data-v-0537d54a]{font-weight:700;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0537d54a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Monitoring.vue
// module id = 694
// module chunks = 0